.button-badge{background-color:#ce2d44;border-radius:100%;width:8px;height:8px;position:absolute;top:0;right:0}mat-icon{position:relative}
/*# sourceMappingURL=toggle-feedback-list-button.component.css.map */
